import React from 'react'
import PropTypes, { InferProps } from 'prop-types'
import styled from 'styled-components'
import { usePartner } from '@pcln/partner-config'
import { Button } from 'pcln-design-system'

const StyledButton = styled(Button)`
  height: 56px;
`

export default function SearchFormButton(
  props: InferProps<typeof SearchFormButton.propTypes>
) {
  const { handleClick, buttonText, ...buttonProps } = props
  const partnerButtonText = usePartner('config.searchForm.buttonText')
  const btnText = partnerButtonText || buttonText
  const onClick = () => handleClick && handleClick()
  return (
    <StyledButton
      width={1}
      px={1}
      py={0}
      size="large"
      onClick={onClick}
      type="submit"
      {...buttonProps}
    >
      {btnText}
    </StyledButton>
  )
}

SearchFormButton.propTypes = {
  handleClick: PropTypes.func,
  buttonText: PropTypes.string.isRequired
}

SearchFormButton.defaultProps = {
  handleClick: () => {
    // do nothing
  }
}
